import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import * as S from '../Conecta2ProductPage.styles';
import { getFAQs } from '../constants/productDataI18n';

const FAQSection = () => {
  const t = useTranslation();
  const faqs = getFAQs(t);
  const [openFaq, setOpenFaq] = useState(0);
  console.log(faqs);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <S.Section $background="#f8f9fa">
      <S.Container>
        <S.SectionTitle>{t('conecta2Product.faq.title')}</S.SectionTitle>
        <S.FAQList>
          {faqs.map((faq, index) => (
            <S.FAQItem key={index} onClick={() => toggleFaq(index)}>
              <S.FAQHeader>
                <S.FAQQuestion>{faq.question}</S.FAQQuestion>
                <S.FAQIcon $isOpen={openFaq === index}>
                  <FaChevronDown />
                </S.FAQIcon>
              </S.FAQHeader>
              <S.FAQAnswer $isOpen={openFaq === index}>
                <S.FAQAnswerContent $isOpen={openFaq === index}>
                  {faq.answer}
                </S.FAQAnswerContent>
              </S.FAQAnswer>
            </S.FAQItem>
          ))}
        </S.FAQList>
      </S.Container>
    </S.Section>
  );
};

export default FAQSection;
